import { render, staticRenderFns } from "./ItemTypeEdit.vue?vue&type=template&id=10b6d332&lang=pug"
import script from "./ItemTypeEdit.vue?vue&type=script&lang=js"
export * from "./ItemTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports